<div class="bg-white">
    <h2 class="settings-header px-4 pt-5 pb-3 mb-0">{{'billing' | translate}}</h2>

    <div class="px-4 pb-3 pt-3 bg-grey">
        <div class="row py-2 billing-information">
            <div class="col-md-2">
                <h4>{{'billing_information' | translate}}</h4>
            </div>
            <div class="col-md-8 pt-4">
                @if(loading){
                <p><i class="fa-3x fa-solid fa-sync fa-spin"></i></p>
                } @else {
                <p class="pb-2">{{'max_users_quantity' | translate:{quantity: subscription?.maxQuantity} }} {{subscription?.subscription_end | date:'mediumDate' }}.</p>
                <p class="pb-2">{{'actual_users_quantity' | translate:{quantity: subscription?.currentQuantity} }}</p>
                @if (subscription?.maxQuantity < subscription?.currentQuantity){
                    <div class="alert alert-warning" role="alert">
                        {{'over_quota' | translate:{by:(subscription?.currentQuantity-subscription?.maxQuantity)} }}
                    </div>
                }
                <p class="pb-2">{{'yearly_billing.contact_from_you' | translate}} <span style="font-style: italic">{{subscription?.contact}}</span></p>
                <p><button class="btn btn-primary" routerLink="/setup/billing/details">{{ 'yearly_billing.view_details' | translate}}</button></p>
                }
            </div>
        </div>
            <hr>
        <div class="row">
                <div class="col-md-2 col-md-offset-1">
                    <h4>{{'contact_us' | translate}}</h4>
                </div>
                <div class="col-md-7">
                    <p>{{'yearly_billing.contact_us' | translate}} <a href="mailto:billing@teammood.com?subject=Billing%20question">billing&#64;teammood.com</a></p>
                </div>
            </div>
        <hr>
    </div>

</div>

